var map = {
	"./autobew_44.png": 707,
	"./boardwPen.png": 239,
	"./boardwhook.png": 301,
	"./building.png": 1604,
	"./cemet.png": 1605,
	"./church.png": 1606,
	"./cigarette_44_neu.png": 699,
	"./dustbin_44.png": 702,
	"./economicy.png": 1607,
	"./edu.png": 1608,
	"./email.png": 554,
	"./explanation.png": 271,
	"./fountain_44.png": 708,
	"./hydrant_44.png": 706,
	"./icon_dog_44.png": 700,
	"./icon_ranking.png": 711,
	"./info.png": 712,
	"./info_blue.png": 419,
	"./medical.png": 1609,
	"./other.png": 1610,
	"./passport.png": 1611,
	"./recycle_new_44.png": 701,
	"./sms.png": 555,
	"./sonstWasser_44.png": 710,
	"./task_finished.png": 418,
	"./task_inprogress.png": 415,
	"./task_open.png": 416,
	"./task_planned.png": 417,
	"./trash.png": 1612,
	"./tree.webp": 302,
	"./vehicle.png": 420,
	"./vote.png": 1613,
	"./water_44.png": 709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1603;